
export default {
  props: ['text', 'link', 'active', 'no_svg'],
};
